import { Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { UseStylesProps } from './TemplateCard.types';

export const useStyles = makeStyles<Theme, UseStylesProps>(
  ({
    spacing,
    palette: { primary, green, white, info, scorpionGray },
    typography: { body1, fontWeightBold },
    breakpoints,
  }) => ({
    templateCardContainer: {
      border: ({ selected }) =>
        selected ? `solid ${spacing(0.25)} ${primary.main}` : `solid ${spacing(0.25)} ${white.main}`,
      borderRadius: spacing(0.75),
      display: 'flex',
      flexWrap: 'nowrap',
      position: 'relative',
      flexDirection: 'column',
      margin: '10px',
      // width: '408px',
      // height: '270px',
      '&:hover': {
        boxShadow: ` ${spacing(0, 0.5, 1, 0)}  ${info.main}`,
        cursor: 'pointer',
      },

      '@media (max-width:375px)': {
        margin: spacing(1, 4, 1, 4),
      },
      '@media (max-width:320px)': {
        margin: spacing(1, 7.5, 1, 7.5),
      },
    },
    imageContainer: {
      ...body1,
      width: '100%',
      whiteSpace: 'break-spaces',
      height: '100%',
      '& .MuiSkeleton-root': {
        transform: 'none', // Override transform for Skeleton in the image container
      },
    },
    title: {
      fontSize: spacing(1.875),
      fontFamily: 'Open Sans',
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'flex-start',
      marginLeft: '4px',
      padding: '2px',
      marginTop: '10px',
      '@media (max-width:375px)': {
        fontSize: spacing(1.5),
      },
      '@media (max-width:320px)': {
        fontSize: spacing(1.25),
      },
    },
    dot: {
      position: 'absolute',
      width: spacing(3),
      height: spacing(3),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: green.main,
      color: primary.contrastText,
      borderRadius: '100%',
      top: spacing(1),
      right: spacing(1),
    },
    checkedIcon: {
      width: spacing(2),
      height: spacing(2),
    },
    avatarLoader: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
    },
    bold: {
      fontWeight: fontWeightBold,
      marginLeft: '4px',
      // color: error.main,
    },
    buttonText: {
      fontSize: spacing(2),
      fontWeight: spacing(87.5),
      fontFamily: 'Open Sans',
      backgroundColor: green.dark,
      color: white.main,
      letterSpacing: '0px',
      padding: '2px 8px',
      '&:hover': {
        backgroundColor: scorpionGray.dark,
      },
      [breakpoints.down('sm')]: {
        width: '100%',
      },
      '@media (max-width:375px)': {
        fontSize: spacing(2),
      },
      '@media (max-width:320px)': {
        fontSize: spacing(1.5),
      },
    },
  }),
);
